import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#0A2540] to-[#1E3A5F] text-white py-6">
        <div className="container mx-auto px-4">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-white hover:bg-white/10 mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Button>
          <h1 className="text-4xl font-bold">Impressum</h1>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 prose prose-lg max-w-none">
          <h2>Dienstanbieter</h2>
          <p><strong>Seeschloss-GbR</strong></p>
          <p>auftretend als <strong>See Schlosshotel am Kellersee</strong></p>
          
          <h3>Betriebsstätte (Hotelbetrieb)</h3>
          <p>
            Leonhart-Boldt-Straße 19<br />
            23701 Eutin · Deutschland
          </p>
          
          <h3>Sitz der Gesellschaft</h3>
          <p>
            Lauritz Maßmannstr. 11<br />
            23774 Heiligenhafen · Deutschland
          </p>
          
          <p>
            Kontakt: <a href="mailto:info@seeschlosshotel-kellersee.com">info@seeschlosshotel-kellersee.com</a><br />
            Website: <a href="https://seeschlosshotel-kellersee.de">https://seeschlosshotel-kellersee.de</a>
          </p>
          
          <p>Vertretungsberechtigte Gesellschafter: A. Malik, Dr. Grote</p>
          <p>Steuernummer: 25/73/06482</p>
          
          <h2>Redaktionell-verantwortlich (§ 18 Abs. 2 MStV)</h2>
          <p>
            <strong>A. Malik</strong> - Inhaltlich verantwortliche Person<br />
            Leonhart-Boldt-Straße 19, 23701 Eutin
          </p>
          <p>
            <strong>Dr. Grote</strong> - Inhaltlich verantwortliche Person<br />
            Lauritz Maßmannstr. 11, 23774 Heiligenhafen
          </p>
          <p>
            <strong>Daniel Böttche</strong> - Webredaktion<br />
            Fischerstraße 10, 23730 Neustadt<br />
            <a href="https://webvision-nord.de/">WebVision-Nord.de</a>
          </p>
          
          <h2>Technische Realisierung</h2>
          <p>
            <strong>WebVision-Nord.de</strong> - Konzept · Design · Umsetzung<br />
            Vertreten durch Daniel Böttche<br />
            Fischerstraße 10, 23730 Neustadt<br />
            <a href="https://webvision-nord.de/">Website</a>
          </p>
          
          <h2>Verbraucherstreitbeilegung / OS-Plattform</h2>
          <p>
            Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an einem Streitbeilegungsverfahren 
            vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
          <p>
            Plattform der EU-Kommission zur Online-Streitbeilegung:{' '}
            <a href="https://consumer-redress.ec.europa.eu/index_de">
              https://consumer-redress.ec.europa.eu/index_de
            </a>
          </p>
          
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den 
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, 
            übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, 
            die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
            Gesetzen bleiben hiervon unberührt. Eine Haftung ist jedoch erst ab Kenntnis einer konkreten 
            Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen entfernen wir Inhalte umgehend.
          </p>
          
          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites, auf deren Inhalte wir keinen Einfluss haben. 
            Für diese fremden Inhalte übernehmen wir keine Gewähr. Für die Inhalte der verlinkten Seiten ist 
            stets der jeweilige Anbieter oder Betreiber verantwortlich. Rechtswidrige Inhalte waren zum Zeitpunkt 
            der Verlinkung nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen entfernen wir solche Links umgehend.
          </p>
          
          <h2>Urheberrecht</h2>
          <p>
            Die von uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
            Beiträge Dritter sind als solche gekennzeichnet. Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
            der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der vorherigen Zustimmung des jeweiligen 
            Rechteinhabers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht-kommerziellen Gebrauch 
            gestattet.
          </p>
          <p>Bildnachweise: eigene Aufnahmen; ggf. weitere Quellen am Bild vermerkt.</p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
